import { ConditionalLink } from "components/conditionalLink";
import DashboardContainer from "components/dashboard/DashboardContainer";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "components/DesignSystem/ToggleGroup/ToggleGroup";
import { Icon1099 } from "components/icons/Icon1099";
import { Wform } from "components/icons/Wform";
import { ReviewTransactionsWithoutVendor } from "components/ReviewTransactionsWithoutVendor/ReviewTransactionsWithoutVendor";
import { MerchantsPanel } from "components/Vendors/merchantsPanel";
import { VendorsFilter } from "components/Vendors/VendorsFilter";
import { INKLE_WEBSITE_URL } from "constants/base";
import { CURRENT_SEASON } from "constants/vendor";
import { VendorFilterProps } from "./Vendors";

const InfoBanner = () => {
  return (
    <div className="t-rounded-lg t-p-4 t-w-full t-shadow-[0px_1px_8px_-1px_rgba(31,12,92,0.04)] t-border-solid t-border-neutral-0 t-border">
      <div className="t-flex t-gap-6 sm:t-flex-col sm:t-gap-4">
        <div className="t-flex t-gap-4 t-items-center t-flex-1 sm:t-flex-col sm:t-items-start sm:t-gap-3">
          <div className="t-shrink-0">
            <Wform className="sm:t-h-8 sm:t-w-auto" />
          </div>
          <p className="t-m-0 t-text-body-sm t-text-text-30">
            A tax document used in the U.S. for reporting income earned by U.S.
            residents or foreign entities.{" "}
            <ConditionalLink
              to={`${INKLE_WEBSITE_URL}blog/irs-form-1099#step-by-step-instructions-for-completing-form-w-9`}
              className="t-text-text-30 t-font-bold !t-underline"
            >
              Know more
            </ConditionalLink>
          </p>
        </div>

        <div className="t-border-0 t-border-solid t-border-l t-border-neutral-0 sm:t-border-l-0 sm:t-border-t sm:t-w-full" />

        <div className="t-flex t-gap-4 t-items-center t-flex-1 sm:t-flex-col sm:t-items-start sm:t-gap-3">
          <div className="t-shrink-0">
            <Icon1099 className="sm:t-h-8 sm:t-w-auto" />
          </div>
          <p className="t-m-0 t-text-body-sm t-text-text-30">
            Form 1099 is an essential tax document that reports non-employment
            income to the Internal Revenue Service (IRS).{" "}
            <ConditionalLink
              to={`${INKLE_WEBSITE_URL}blog/irs-form-1099`}
              className="t-text-text-30 t-font-bold !t-underline"
            >
              Know more
            </ConditionalLink>
          </p>
        </div>
      </div>
    </div>
  );
};

type VendorsContentProps = {
  groupId: string;
  entityId: string;
} & VendorFilterProps;

export const VendorsContent = ({
  groupId,
  entityId,
  updateFilter,
  filter,
  updateMultipleFilters,
}: VendorsContentProps) => {
  const onShowEstimated1099 = () => {
    updateFilter("SHOW_ESTIMATED_1099", !filter.SHOW_ESTIMATED_1099);
    if (!filter.SEASON) {
      updateFilter("SEASON", CURRENT_SEASON);
    }
    updateFilter("VENDOR_TYPE", null);
  };

  return (
    <DashboardContainer>
      <DashboardContainer.Header>
        <div className="t-flex t-gap-4 t-flex-col">
          <div className="t-w-[400px] sm:t-w-full">
            <ToggleGroup
              type="single"
              size="small"
              value={filter.SHOW_ESTIMATED_1099 ? "W-FORMS" : "ALL"}
              onValueChange={onShowEstimated1099}
              className="t-w-full"
            >
              <ToggleGroupItem value="ALL">All Vendors</ToggleGroupItem>
              <ToggleGroupItem value="W-FORMS">
                Vendors requiring W-Forms
              </ToggleGroupItem>
            </ToggleGroup>
          </div>

          <ReviewTransactionsWithoutVendor
            groupId={groupId}
            entityId={entityId}
            season={filter.SEASON ? Number(filter.SEASON) : undefined}
          />
          <InfoBanner />
        </div>
      </DashboardContainer.Header>
      <DashboardContainer.Content className="t-relative t-flex t-flex-col t-gap-5 t-mt-5 sm:t-overflow-x-hidden sm:t-overflow-y-visible sm:t-min-w-0">
        <MerchantsPanel
          vendorFilter={
            <VendorsFilter
              updateMultipleFilters={updateMultipleFilters}
              updateFilter={updateFilter}
              filter={filter}
            />
          }
          filters={filter}
        />
      </DashboardContainer.Content>
    </DashboardContainer>
  );
};
